<!--
 * @Author: zhengxiaoxiao
 * @Date: 2020-05-29 15:43:09
 * @Description: 企业文化
--> 

<template>
	<div class="culture-chunk">
		<div class="culture-left">
			<h1 class="p1">{{$t("about.culture")}}</h1>
			<template v-for="item in cultureList">
				<h2>{{item.title}}</h2>
				<p>{{item.content}}</p>
			</template>
		</div>
		<img src="../../../assets/metaCulture.jpg" />
	</div>
</template>
<script>
export default {
	data() {
		this.cultureList = [
			// {
			// 	title: this.$t('home.values'),
			// 	content: this.$t('home.valuesText'),
			// },
			{
				title: this.$t('home.mission'),
				content: this.$t('home.missionText'),
			},
			{
				title: this.$t('home.values'),
				content: this.$t('home.valuesText'),
			},
			{
				title: this.$t('home.vision'),
				content: this.$t('home.visionText'),
			},
		]
		return {}
	},
}
</script>
<style lang="less" scoped>
@import '../../../style/constant';
.culture-chunk {
	width: @page-width;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
	align-items: center;
	.culture-left {
		padding: 80px 0;
	}
	h2 {
		margin: 30px 0 6px 0;
		font-size: 20px;
	}
	p {
		font-size: 14px;
	}
	img {
		max-height: 460px;
	}
}

@media screen and (min-width: 320px) and (max-width: 480px) {
	.culture-chunk {
		padding: 60px 0px 30px;
		flex-direction: column;
		img {
			padding-top: 30px;
		}
		.culture-left {
			padding: 0px 20px;
		}
	}
}
</style>
